import { Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TermsOfUseAgreementRepository } from '@features/terms-of-use/terms-of-use-agreement-repository';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-terms-of-use',
  templateUrl: './terms-of-use.component.html',
})
export class TermsOfUseComponent {
  acceptTermsCheckbox: FormControl = new FormControl(false);

  formGroup = new FormGroup({ acceptTerms: this.acceptTermsCheckbox });

  acceptedTerms$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(
    private repository: TermsOfUseAgreementRepository,
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  toggleAcceptance() {
    this.acceptedTerms$.next(!this.acceptedTerms$.getValue());
  }

  async submitAgreement() {
    this.repository.create().subscribe();

    return this.router.navigateByUrl(this.redirectTo);
  }

  get redirectTo(): string {
    return this.route.snapshot.queryParamMap.get('redirectTo') || '/';
  }
}
